import { ActionKeys } from '~/actions/constants';
import { DialogType } from '~/actions/dialog.actions';
import { ActionTypes } from '~/actions/index';

export type DialogState = {
  readonly activeDialog: Maybe<DialogType>;
  readonly message: Maybe<string>;
  readonly messages: string[];
  readonly title: Maybe<string>;
  readonly confirmButtonText: Maybe<string>;
  readonly closeButtonText: Maybe<string>;
};

const initialState: DialogState = {
  message: null,
  messages: [],
  title: null,
  confirmButtonText: null,
  closeButtonText: null,
  activeDialog: null,
};

function reducer(state: DialogState = initialState, action: ActionTypes) {
  switch (action.type) {
    case ActionKeys.DIALOG_SHOW:
      return {
        ...state,
        activeDialog: action.payload.dialogType,
        messages: action.payload.props.messages,
        title: action.payload.props.title,
        confirmButtonText: action.payload.props.confirmButtonText,
        closeButtonText: action.payload.props.closeButtonText,
      };
    case ActionKeys.DIALOG_HIDE:
      return {
        ...state,
        activeDialog: null,
        messages: [],
        title: null,
        confirmButtonText: null,
        closeButtonText: null,
      };
    default:
      return state;
  }
}

export default reducer;
